import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const SECTIONS = [
  { h: "Information We Collect", p: "We collect information you provide directly — such as name, email, company, and phone number when you submit our contact form or create a client portal account." },
  { h: "How We Use Information", p: "Information is used to respond to inquiries, deliver our services, operate the client portal, and improve our growth solutions. We do not sell your personal data." },
  { h: "HaloFlow & AI Processing", p: "Where you engage our AI voice and agent stack (HaloFlow), interaction data may be processed to handle intake, scheduling, and lead routing on your behalf." },
  { h: "Data Security", p: "We apply industry-standard safeguards to protect your information. Client portal access is protected by authenticated sessions." },
  { h: "Your Rights", p: "You may request access to, correction of, or deletion of your personal information at any time by contacting us." },
  { h: "Contact", p: "Questions about this policy? Email growth@onthebrink.com." },
];

export default function Privacy() {
  return (
    <div className="bg-white min-h-screen" data-testid="privacy-page">
      <Navbar />
      <main className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-ember">Legal</p>
          <h1 className="mt-4 font-heading font-extrabold tracking-tight text-ink text-4xl sm:text-5xl">Privacy Policy</h1>
          <p className="mt-4 text-slatey">Last updated: {new Date().toLocaleDateString()}</p>
          <div className="mt-10 space-y-8">
            {SECTIONS.map((s) => (
              <div key={s.h}>
                <h2 className="font-heading font-bold text-ink text-xl">{s.h}</h2>
                <p className="mt-3 text-slatey leading-relaxed">{s.p}</p>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
